import React from 'react';

import styles from './ContentTitleCard.scss';
import Button from 'Components/Button';

function ContentTitleCard({ backgroundImageURL, mediaType, onStartGame }) {
  const style = {
    backgroundImage: `url("${backgroundImageURL}")`,
  };
  return (
    <div className="ContentTitleCard" style={style}>
      <Button
        text="Play Now"
        buttonSize="hero"
        buttonContext="on-canvas"
        withAction={true}
        mediaType={mediaType}
        customClass=" ContentTitleCard__button"
        clickHandler={onStartGame}
      />
    </div>
  );
}

export default ContentTitleCard;
